
export const types = {
  SIDEBAR_TOGGLED: 'app/uiState/SIDEBAR_TOGGLED',
  SHOW_NOTIFICATION: 'app/systemNotification/SHOW',
  DISMISS_NOTIFICATION: 'app/systemNotification/DISMISS',

  CLEAR_API_ERRORS: 'app/uiState/CLEAR_API_ERRORS',
  RECEIVE_API_ERROR: 'app/uiState/RECEIVE_API_ERROR',
  PAGE_IS_WAITING: 'app/uiState/PAGE_IS_WAITING',
  UPDATE_PAGE_STATE: 'app/uiState/UPDATE_PAGE_STATE',

  START_BACKGROUND_PROCESS: 'app/uiState/START_BACKGROUND_PROCESS',
  CLEAR_BACKGROUND_PROCESS: 'app/uiState/CLEAR_BACKGROUND_PROCESS',
};

function openSidebar() {
  const bodyTag = document.getElementsByTagName('body')[0];
  bodyTag.classList.add('global-sidebar-open');
  return {
    type: types.SIDEBAR_TOGGLED,
    payload: {
      sidebarOpen: true,
    },
  }
}

function closeSidebar() {
  const bodyTag = document.getElementsByTagName('body')[0];
  bodyTag.classList.remove('global-sidebar-open');
  return {
    type: types.SIDEBAR_TOGGLED,
    payload: {
      sidebarOpen: false,
    },
  };
}

function showNotification(message, color) {
  return {
    type: types.SHOW_NOTIFICATION,
    payload: {
      systemNotification: {
        message,
        color,
      },
    },
  };
}

function showApiError(apiError, color) {
  return {
    type: types.SHOW_NOTIFICATION,
    payload: {
      systemNotification: {
        message: apiError.messageKey(),
        color,
      },
    },
  };
}

function dismissNotification() {
  return {
    type: types.CLEAR_API_ERRORS,
    payload: {
      systemNotification: {
        message: '',
        color: '',
      },
    },
  };
}

function clearErrors() {
  return {
    type: types.CLEAR_API_ERRORS,
    payload: {
      apiError: {},
    },
  };
}

function receivedApiError(apiError) {
  return {
    type: types.RECEIVE_API_ERROR,
    payload: {
      apiError,
    },
  };
}

function pageIsWaiting(isWaiting) {
  return {
    type: types.PAGE_IS_WAITING,
    payload: {
      isWaiting,
    },
  };
}

function startFileUpload(uploadRequestPromise) {
  return {
    type: types.START_FILE_UPLOAD,
    payload: {
      uploadRequestPromise,
    },
  };
}

function finishFileUpload() {
  return {
    type: types.FINISH_FILE_UPLOAD,
    payload: {
      uploadRequestPromise: null,
    },
  };
}

function updatePageState(data) {
  return {
    type: types.UPDATE_PAGE_STATE,
    payload: data,
  }
}

function startBackgroundProcess(identifier, processName, data) {
  return {
    type: types.START_BACKGROUND_PROCESS,
    payload: {
      identifier,
      processName,
      data,
    },
  };
}

function clearBackgroundProcess(identifier, processName) {
  return {
    type: types.CLEAR_BACKGROUND_PROCESS,
    payload: {
      identifier,
      processName,
    },
  };
}

function startDataExportArchiveProcess(identifier, data) {
  return startBackgroundProcess(identifier, 'dataExportArchive', data);
}

function clearDataExportArchiveProcess(identifier) {
  return clearBackgroundProcess(identifier, 'dataExportArchive');
}

const actions = {
  openSidebar,
  closeSidebar,
  showNotification,
  showApiError,
  dismissNotification,
  clearErrors,
  receivedApiError,
  pageIsWaiting,
  updatePageState,
  startBackgroundProcess,
  clearBackgroundProcess,
  startDataExportArchiveProcess,
  clearDataExportArchiveProcess,
};


export default actions;
